// EditorialFeatureList, "Table of Contents" feature row.
//
// Vertical editorial index. Each row carries a large monospace number
// on the left, a serif title in the middle, and a sans-serif blurb on
// the right, divided by hairline rules. Designed to read like the
// contents page of a magazine, authoritative, scannable, no SaaS box
// vibe, no SaaS icons.
const FEATURES = [
  {
    title: 'Feed discovery',
    description: 'Watch real work, not posed photos. See stylists in motion and book the look that catches your eye.',
  },
  {
    title: 'Guest checkout',
    description: 'Book an appointment in minutes, no account needed. Track and manage it from your confirmation email.',
  },
  {
    title: 'Smart waitlists',
    description: 'Fully booked day? Join the waitlist in one tap. We text you the moment a slot opens up.',
  },
  {
    title: 'Real-time booking',
    description: 'Each stylist publishes live availability. Lock in your slot instantly, with SMS reminders included.',
  },
  {
    title: 'Mobile or salon',
    description: 'Book at the salon, or have your stylist come to you. Your choice every time.',
  },
  {
    title: 'Reviews that count',
    description: 'Every review is from a client who genuinely booked. No bots, no paid placements.',
  },
];

export function EditorialFeatureList() {
  return (
    <section className="bg-white py-20 lg:py-28" data-testid="editorial-features">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="mb-12 lg:mb-16 max-w-3xl">
          <span className="overline">Contents</span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium text-[#1A1A1A] mt-3 leading-[1.05]">
            What you get, <span className="italic text-stone-500">on every booking.</span>
          </h2>
        </div>

        {/* The list. Hairline rules, no icons, magazine-contents feel. */}
        <ol className="divide-y divide-stone-200 border-y border-stone-200">
          {FEATURES.map((feature, idx) => (
            <li
              key={feature.title}
              className="group grid grid-cols-12 items-start gap-6 py-7 lg:py-9 transition-colors duration-300 hover:bg-[#F9F6F0]"
              data-testid={`feature-row-${idx + 1}`}
            >
              {/* Issue number */}
              <span className="col-span-2 lg:col-span-1 font-mono text-xs lg:text-sm text-stone-400 tracking-widest pt-2">
                {String(idx + 1).padStart(2, '0')}
              </span>

              {/* Title */}
              <h3 className="col-span-10 lg:col-span-5 font-heading text-2xl lg:text-3xl leading-tight tracking-tight text-[#1A1A1A]">
                {feature.title}
              </h3>

              {/* Deck */}
              <p className="col-start-3 lg:col-start-auto col-span-10 lg:col-span-6 text-stone-600 text-base leading-relaxed">
                {feature.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
